<header id="header" class="header-container display-flex-container">
  <!--LOGO CONTAINER-->
  <div class="logo-container">
    <a id="headerLogoLink" href="javascript:void(0)" routerLink="/home">
      <img id="logo" class="logo" alt="RIDE COMMAND®" [ngSrc]="logoUrl" i18n-alt />
    </a>
  </div>
  <rdx-primary-nav />

  <div id="nav-secondary" class="secondary-nav-container">
    <ul class="list-inline">
      @if (!isProd) {
        <li>
          <rdx-info-link />
        </li>
      }
      @if (isStage) {
        <li class="stage">
          <!-- eslint-disable-next-line @angular-eslint/template/i18n -->
          <a href="javascript:void(0)" (click)="goToStage()">Stage - Go To Test</a>
        </li>
      }

      @if (isAuthenticated) {
        <li class="notification-bell helper-set-position">
          <rdx-notification />
        </li>
      }
    </ul>
  </div>
</header>
